import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, Typography, useMediaQuery } from '@mui/material';
import Modal from '@mui/material/Modal';
import React from 'react';
import { useAccessibility } from '../../Store/contexts/AccessibilityContext';
import checkIcon from '../../assets/images/circle-check.png';
import errorIcon from '../../assets/images/octagon-xmark.svg';
import warningIcon from '../../assets/images/triangle-exclamation.png';
import { ModalActionProps } from '../../interfaces/props/ModalActionProps';
import './styles.css';
import { sxButton, sxButtonContained, sxCloseIconButton, sxTextButton, sxTypographySubTitle, sxTypographyTitle } from './sxProps';
import parse from 'html-react-parser';
interface ModalActionResponsiveProps extends ModalActionProps {
  className?: string
  width?: string
}

const ModalActionResponsive: React.FC<ModalActionResponsiveProps> = ({
  showModal, handleShowModal,
  title, subTitle, icon,
  colorContainedButton,
  textContainedButton,
  textOutlinedButton,
  handleContainedButton,
  handleOutlinedButton,
  className,
  width
}) => {

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  const selecionarIcone = (icon: 'error' | 'success' | 'warning'): string => {
    switch (icon) {
      case 'success':
        return checkIcon;
      case 'error':
        return errorIcon;
      case 'warning':
        return warningIcon;
      default:
        return checkIcon;
    }
  };

  const getColorContainedButton = (icon: 'error' | 'success' | 'warning' | undefined): 'error' | 'success' | 'warning' => {
    if (colorContainedButton) return colorContainedButton
    switch (icon) {
      case 'error': case 'warning':
        return 'error';
      case 'success':
        return 'success';
      default:
        return 'success'
    }
  };

  const outlinedButton =
    <Button
      style={buttonStyleAccessibility}
      onClick={handleOutlinedButton}
      sx={sxButton}
      variant={'outlined'}
    >
      <Typography style={{ ...buttonTextStyleAccessibility, color: '#00995D' }} sx={sxTextButton}>{textOutlinedButton}</Typography>
    </Button>

  const containedButton =
    <Button
      style={buttonStyleAccessibility}
      onClick={handleContainedButton}
      sx={{
        ...sxButtonContained,
        background: getColorContainedButton(icon) === 'error' ? '#d32f2f' : '#00995D',
        "&:hover": {
          background: getColorContainedButton(icon) === 'error' ? '#8F1131' : '#164029',
        },
      }}
      variant={'contained'}
      color={getColorContainedButton(icon)}
    >
      <Typography style={buttonTextStyleAccessibility} sx={sxTextButton}>{textContainedButton}</Typography>
    </Button>


  return (
    <Modal
      open={showModal}
      onClose={handleShowModal}
    >
      <div style={{ ...textStyleAccessibility, width }} className={`container-modal-action-responsive ${className || ''}`}>
        <IconButton
          aria-label="fechar"
          onClick={handleShowModal}
          sx={sxCloseIconButton}
        >
          <FontAwesomeIcon icon={faTimes} size="1x" color='black' />
        </IconButton>
        <div className='action-modal-box-title-responsive'>
          {icon &&
            <div>
              <img src={selecionarIcone(icon)} alt="" />
            </div>
          }
          <Typography sx={sxTypographyTitle} component="h1">{title}</Typography>
        </div>
        <div className='modal-typography-scroll-responsive'>
          <Typography sx={sxTypographySubTitle}>
            {typeof subTitle === 'string' ? parse(subTitle) : subTitle}
          </Typography>
        </div>
        <div className='action-modal-buttons-holder-responsive'>
          {outlinedButton}
          {containedButton}
        </div>
      </div>
    </Modal>
  );
};

export default ModalActionResponsive;